import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { updateDoorRule } from "../../../features/precificador/services/door-count-rule";
import { DoorRuleProps } from "../../../features/precificador/types/door-rule";

export const doorRuleActiveLabel = (active: boolean) =>
	active ? "Ativa" : "Inativa";

type DoorRuleToggleProps = {
	rule: Pick<DoorRuleProps, "id" | "active">;
	onToggled?: (rule: DoorRuleProps) => void;
};

export default function DoorRuleToggle({
	rule,
	onToggled,
}: DoorRuleToggleProps): JSX.Element {
	const [active, setActive] = useState<boolean>(rule.active);
	const [toggling, setToggling] = useState<boolean>(false);

	useEffect(() => {
		setActive(rule.active);
	}, [rule.active]);

	const handleChange = async (nextActive: boolean) => {
		setToggling(true);
		setActive(nextActive);
		try {
			const updated = await updateDoorRule(rule.id, { active: nextActive });
			toast.success(nextActive ? "Regra ativada." : "Regra desativada.", {
				position: toast.POSITION.TOP_RIGHT,
			});
			onToggled?.(updated);
		} catch (error) {
			setActive(rule.active);
			const message =
				error instanceof Error ? error.message : "Falha ao alterar a regra.";
			toast.error(message, { position: toast.POSITION.TOP_RIGHT });
		} finally {
			setToggling(false);
		}
	};

	return (
		<FormControlLabel
			onClick={(e) => e.stopPropagation()}
			control={
				<Switch
					checked={active}
					disabled={toggling}
					onChange={(e) => handleChange(e.target.checked)}
				/>
			}
			label={doorRuleActiveLabel(active)}
		/>
	);
}
